<template>
    <section>
        <div class="row justify-content-end">
            <div class="col">
                <nav aria-label="breadcrumb">
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item h3 font-weight-bold mb-0">
                            <router-link v-bind:to="{ name: 'schedule/index' }">
                                Jadwal
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active font-weight-medium" aria-current="page">
                            Absensi Siswa
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <h4 class="font-weight-bold text-danger">Sesi {{ session.slot }}</h4>
            </div>
        </div>
        <div class="row">
            <div class="col-auto mb-3">
                <h4 class="mb-1 text-muted font-weight-medium">Cabang</h4>
                <p class="font-weight-bold mb-0">{{ session.branchClass.pattern.branchProgram.branch.name }}</p>
            </div>
            <div class="col-auto mb-3">
                <h4 class="mb-1 text-muted font-weight-medium">Kelas</h4>
                <p class="font-weight-bold mb-0">{{ session.branchClass.pattern.branchProgram.grade.name }}</p>
            </div>
            <div class="col-auto mb-3">
                <h4 class="mb-1 text-muted font-weight-medium">Tipe Program</h4>
                <p class="font-weight-bold mb-0">{{ session.branchClass.pattern.branchProgram.programType.name }}</p>
            </div>
            <div class="col-auto mb-3">
                <div class="row">
                    <div class="col-auto">
                        <h4 class="mb-1 text-muted font-weight-medium">Hari Pola</h4>
                        <p class="font-weight-bold mb-0" v-for="period in session.branchClass.pattern.periods" v-bind:key="period.id">
                            {{ $moment.weekdays(period.day) }}
                        </p>
                    </div>
                    <div class="col-auto">
                        <h4 class="mb-1 text-muted font-weight-medium">Sesi Pola</h4>
                        <p class="font-weight-bold mb-0" v-for="period in session.branchClass.pattern.periods" v-bind:key="period.id">
                            {{ [period.start, "HH:mm:ss"] | moment("HH.mm") }} - {{ [period.end, "HH:mm:ss"] | moment("HH.mm") }} ({{ period.slots }})
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-auto mb-3">
                <h4 class="mb-1 text-muted font-weight-medium">Nama Kelas</h4>
                <p class="font-weight-bold mb-0">{{ session.branchClass.name }}</p>
            </div>
            <div class="col-auto mb-3">
                <h4 class="mb-1 text-muted font-weight-medium">Kapasitas</h4>
                <p class="font-weight-bold mb-0" v-for="(capacityAttribute, index) in capacityAttributes">Semester {{ index + 1 }}: {{ session.branchClass[capacityAttribute] }}/{{ session.branchClass.capacity }}</p>
            </div>
            <div class="col-auto mb-3">
                <h4 class="mb-1 text-muted font-weight-medium">Tanggal</h4>
                <p class="font-weight-bold mb-0">{{ [session.date, "YYYY-MM-DD"] | moment("dddd, D MMMM YYYY") }}</p>
            </div>
            <div class="col-auto mb-3">
                <h4 class="mb-1 text-muted font-weight-medium">Periode</h4>
                <p class="font-weight-bold mb-0">{{ periodLabel(session) }}</p>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-10 col-12">
                <div class="row">
                    <div class="col-12 text-right">
                        <button type="button" class="btn btn-sm btn-outline-danger" v-on:click="allAttend">
                            Masuk <i class="fa fa-check"></i>
                        </button>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-5">
                        <form v-on:submit.prevent="save()">
                            <div class="table-responsive">
                                <table class="table">
                                    <thead>
                                        <tr class="text-danger font-weight-bold">
                                            <th scope="col">
                                                NIP
                                            </th>
                                            <th scope="col">
                                                Nama Lengkap
                                            </th>
                                            <th scope="col">
                                                Kehadiran
                                            </th>
                                            <th scope="col">
                                                Hapus
                                            </th>
					       <th scope="col" v-for="profileLabel in profileLabels" v-bind:name="profileLabel" >
                                        		{{ humanize(profileLabel) }} <i class="fa fa-chevron-down"></i>
                                    	    	</th>
                                	                                            </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="shadow-sm" v-for="(student, index) in session.students">
                                            <td>
                                                <span class="text-loading">{{ student.identity }}</span>
                                            </td>
                                            <td>
                                                <span class="text-loading">{{ student.user.name }}</span>
                                            </td>
                                            <td>
                                                <div class="form-check form-check-inline py-1 mr-4" v-for="status in statuses">
                                                    <div class="custom-control custom-radio">
                                                        <input v-model="form.attendances[index].statusID" type="radio" class="custom-control-input" v-bind:value="status.id" v-bind:id="'input-status-' + index + '-' + status.id" />
                                                        <label class="custom-control-label" v-bind:for="'input-status-' + index + '-' + status.id">{{ status.name }}</label>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <button v-if="form.attendances[index].statusID" class="btn btn-link btn-sm" type="button" v-on:click="form.attendances[index].statusID = ''">
                                                    <i class="fa fa-times"></i>
                                                </button>
                                            </td>
				  	    
                                    <td v-for="profileLabel in profileLabels">
                                        <span v-bind:class="{'text-loading': typeof student.additionals[profileLabel] === typeof undefined}">{{ renderCheckBlank(student.additionals[profileLabel]) }}</span>
                                    </td>

                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="row">
                                <div class="col text-right">
                                    <button type="submit" class="btn btn-danger btn-sm px-5">
                                        Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
        import { semesters } from '@/params.js';

    export default {
        name: "ScheduleAttend",
	
        data() {
            return {
                form: {
                    attendances: []
                },
                session: {branchClass: {pattern: {branchProgram: {branch: {}, grade: {}, programType: {}}}}},
                statuses: [],
		                semesters: semesters,
                capacityAttributes: ['currentCapacity', 'secondCurrentCapacity']
            };
        },
        methods: {
            save() {
                this.axios.post(process.env.API_URL + '/attendance', Object.assign({}, this.form, {sessionID: this.session.id})).then(response => {
                    if (response.data.status) {
			this.students = response.data.data.data;
                        this.$toastr('success', response.data.message, 'Success');
                        this.$router.push({name: 'schedule/index'});
                    } else {
                        this.$toastr('warning', response.data.errors[Object.keys(response.data.errors)[0]][0], 'Warning');
                    }
                });
            },
            periodLabel(session) {
                let semester = this.semesters.find(semester => semester.id === session.semester);
                return semester ? semester.name : '';
            },
	    humanize(string) {
                return string.replace(/[_]+/g, ' ').replace(/^[a-z]| [a-z]/g, function (character) {
                    return character.toUpperCase();
                });
            },
            allAttend() {
                if (confirm('Semua status siswa menjadi MASUK, lanjutkan?')) {
                    for (let index in this.form.attendances) {
                        this.form.attendances[index].statusID = this.statuses[0].id;
                    }
                }
            }
        },
        created() {
            this.axios.all([
                this.axios.get(process.env.API_URL + '/session/' + this.$route.params.id),
                this.axios.get(process.env.API_URL + '/attendance-status')
            ]).then(this.axios.spread(function (responseSession, responseStatus) {
                this.session = responseSession.data.data;
                this.statuses = responseStatus.data.data;

                this.form.attendances = this.session.students.map(student => {
                    return {statusID: student.attendance ? student.attendance.attendanceStatusID : '', studentID: student.userID};
                });
            }.bind(this)));

            document.title = 'Absensi Siswa - ' + process.env.APP_NAME;
        }
    };
</script>

<style scoped>
    .table-responsive { cursor: default; }
    .form-check input[type="radio"] + label { cursor: pointer; }
</style>


// WEBPACK FOOTER //
// src/components/schedule/Attend.vue